import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components/macro";
import * as Yup from "yup";
import { Formik } from "formik";
import axios from "../../CustomAxios";

import {
  Alert as MuiAlert,
  Button,
  TextField as MuiTextField,
} from "@mui/material";
import { spacing } from "@mui/system";

const Alert = styled(MuiAlert)(spacing);

const TextField = styled(MuiTextField)(spacing);

function UpdatePassword() {
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [searchParam, setSearchParam] = useSearchParams();
  const userType = searchParam.get("user");
  const [err, setErr] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const updatePasswordUser = async (password) => {
    try {
      setLoading(true);
      const config = {
        headers: {
          "x-auth-token": localStorage.getItem("reset_token"),
        },
      };
      const { data } = await axios.post(
        `/api/v1/${userType}/reset_password`,
        {
          password: password,
        },
        config
      );
      if (data.success) {
        setLoading(false);
        localStorage.removeItem("reset_token");
        if (userType === "customer_user") {
          navigate("/login", {
            state: {
              message: "Password changed successfully!",
              alertOpen: true,
            },
          });
        } else if (userType === "ap_user") {
          navigate("/login/ap-user", {
            state: {
              message: "Password changed successfully!",
              alertOpen: true,
            },
          });
        } else if (userType === "super_admin") {
          navigate("/login/admin", {
            state: {
              message: "Password changed successfully!",
              alertOpen: true,
            },
          });
        }
      }
    } catch (e) {
      console.log(e);
      if (e.response.data.error) {
        setErr(e.response.data.error);
      } else {
        setErr("Server Error");
      }
    }
  };

  return (
    <Formik
      initialValues={{
        password: "",
        confirmPassword: "",
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        password: Yup.string()
          .min(8, "Must be at least 8 characters")
          .max(255)
          .required("Required"),
        confirmPassword: Yup.string().when("password", {
          is: (val) => (val && val.length > 0 ? true : false),
          then: Yup.string().oneOf(
            [Yup.ref("password")],
            "Both password need to be the same"
          ),
        }),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          updatePasswordUser(values.password);
        } catch (error) {
          const message = error.message || "Something went wrong";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          {errors.submit && (
            <Alert mt={2} mb={1} severity="warning">
              {errors.submit}
            </Alert>
          )}
          {err ? (
            <Alert mt={2} mb={3} severity="error">
              {err}
            </Alert>
          ) : null}

          <TextField
            type="password"
            name="password"
            label="Password"
            value={values.password}
            error={Boolean(touched.password && errors.password)}
            fullWidth
            helperText={touched.password && errors.password}
            onBlur={handleBlur}
            onChange={handleChange}
            my={3}
          />
          <TextField
            type="password"
            name="confirmPassword"
            label="Confirm password"
            value={values.confirmPassword}
            error={Boolean(touched.confirmPassword && errors.confirmPassword)}
            fullWidth
            helperText={touched.confirmPassword && errors.confirmPassword}
            onBlur={handleBlur}
            onChange={handleChange}
            my={3}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={isSubmitting || loading}
          >
            {loading ? "Updating Password..." : " Update Password"}
          </Button>
        </form>
      )}
    </Formik>
  );
}

export default UpdatePassword;
